export const ATTENDANCE_REQUEST = 'attendance_request'
export const ATTENDANCE_LIST = 'attendance_list'
export const ATTENDANCE_APPROVAL = 'attendance_approval'